import { AppConfig } from './AppConfig';
import { getWindow } from '../window/Window';
import { ExecutionEnvironment } from '@origin-digital/features';

const getEnvironment = (): ExecutionEnvironment | 'talr' => {
  const hostName = getWindow().location.host;
  if (contains(hostName, 'dev')) {
    return 'dev';
  } else if (contains(hostName, 'test')) {
    return 'test';
  } else if (contains(hostName, 'local') || contains(hostName, 'lvh')) {
    return 'local-stub';
  } else if (contains(hostName, 'staging') || contains(hostName, 'preprod')) {
    return 'staging';
  } else if (contains(hostName, 'talr')) {
    return 'talr';
  }
  return 'prod';
};

const contains = (hostName, search) => {
  return hostName.indexOf(search) !== -1;
};

let config: AppConfig;
const initialise = () => {
  const fileName = getEnvironment() === 'local-stub' ? 'local' : getEnvironment();
  config = require('../config/' + fileName + '.config.json');
};

export const bccbId = Math.random().toString();

const getAppName = () => config.appName;
const getAuth0ClientId = () => config.auth0.auth0ClientId;
const getAuth0Domain = () => config.auth0.auth0Domain;
const getAuth0Host = () => config.auth0.auth0Host;
const getAuth0Tenant = () => config.auth0.auth0Tenant;
const getShouldStubAuth0 = () => config.auth0.shouldStubAuth0;
const getDapiPath = () => config.dapi.apiPath;
const getNewDapiPath = () => config.dapi.newApiPath;
const getDapiApiKey = () => config.dapi.apiKey;
const getGoogleCaptchaKey = () => config.dapi.googleCaptchaKey;
const getAuthCallbackUrl = () => config.paths.authCallbackHref;
const getOnboardingUrl = () => config.paths.onboardingUrl;
const getDashboardUrl = () => config.paths.dashboardUrl;
const getFeedbackUrl = () => config.paths.feedbackUrl;
const getMyAccountUrl = () => config.paths.myAccountUrl;
const accessTokenUrl = () => config.paths.accessTokenUrl;
const getRegisterBootstrapUrl = () => config.paths.registerBootstrapHref;
const getLoginBootstrapUrl = () => config.paths.loginBootstrapHref;
const getIFrameLoginBootstrapUrl = () => config.paths.iframeLoginBootstrapHref;
const getResetPasswordBootstrapUrl = () => config.paths.resetPasswordBootstrapHref;
const getForgotEmailUrl = () => config.paths.forgotEmailAddressHref;
const getErrorPageUrl = () => config.paths.errorHref;
const getCallCentreResetPwThankYouUrl = () => config.paths.callCentrePwResetThankYouHref;
const getCallCentreRegisterThankYouUrl = () => config.paths.callCentreRegisterThankYouHref;
const getHomepageUrl = () => config.paths.homepageHref;
const getLandingUrl = () => config.paths.landing;
const getCloseLoginModalUrl = () => config.paths.closeLoginModalHref;
const getContinueWithoutLoginUrl = () => config.paths.continueWithoutLoginHref;
const getSendOnErrors = () => config.logging.sendOnErrors;
const getSumoCategory = () => config.logging.sourceCategory;
const getSumoConsoleLogLevel = () => config.logging.consoleLogLevel;
const getSumoEndpoint = () => config.logging.endpoint;
const getSumoLogLevel = () => config.logging.sumoLogLevel;
const getSumoSourceEnv = () => config.logging.sourceEnv;
const getConfig = () => config;
const isLiveChatEnabled = () => config.liveChat.enabled;
const getLiveChatAccountId = () => config.liveChat.accountId;
const getLiveChatChatId = () => config.liveChat.chatId;
const getLiveChatInvitationId = () => config.liveChat.invitationId;
const getLiveChatWebsiteId = () => config.liveChat.websiteId;

const env = (key): any => config[key];

export {
  initialise,
  getAppName,
  getAuth0ClientId,
  getAuth0Domain,
  getAuth0Host,
  getAuth0Tenant,
  getAuthCallbackUrl,
  getConfig,
  getEnvironment,
  getOnboardingUrl,
  getDashboardUrl,
  getFeedbackUrl,
  getMyAccountUrl,
  accessTokenUrl,
  getDapiApiKey,
  getDapiPath,
  getNewDapiPath,
  getGoogleCaptchaKey,
  getHomepageUrl,
  getLandingUrl,
  getRegisterBootstrapUrl,
  getForgotEmailUrl,
  getSendOnErrors,
  getShouldStubAuth0,
  getSumoCategory,
  getSumoConsoleLogLevel,
  getSumoEndpoint,
  getSumoLogLevel,
  getSumoSourceEnv,
  getLoginBootstrapUrl,
  getIFrameLoginBootstrapUrl,
  getResetPasswordBootstrapUrl,
  getErrorPageUrl,
  env,
  isLiveChatEnabled,
  getLiveChatAccountId,
  getLiveChatChatId,
  getLiveChatInvitationId,
  getLiveChatWebsiteId,
  getCallCentreRegisterThankYouUrl,
  getCallCentreResetPwThankYouUrl,
  getCloseLoginModalUrl,
  getContinueWithoutLoginUrl,
};
